import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
.module('bringoz.admin.agreements')
.factory('agreementAPI', AgreementAPI);

function AgreementAPI(): BringozApi {
  return {
    base: `/agreements`,
    infiniteScroll: {
      address: `/agreements`,
      cmd: 'GET'
    },
    actions: {
      createVersion: {
        cmd: 'PUT',
        updateable : false,
        address : '{agreementId}'
      },
      updateVersion: {
        cmd: 'PUT',
        updateable : false,
        address : '{agreementId}'
      }
    }
  }
}
